/* @ngInject */
const ownerIcons = () => {
  const self = {}

  self.society = 'contacts'
  self.address = 'business'
  self.cp = 'business'
  self.city = 'business'
  self.country = 'my_location'
  self.contactCount = 'contacts'

  return self
}

export default ownerIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/resources/icons.resource.js